import axios from 'axios'
import { Base64 } from 'js-base64';
import {ElMessageBox} from 'element-plus'

// 创建通用axios配置
let instance = axios.create({
	responseType:"json",
	headers:{'Content-Type':'application/json'}
})

// 对token加密
function baseFun(){
	const token = localStorage.getItem('token')//从本地缓存里取出token
	//const base64 = Base64.encode(token + ':')//对token加密
	//return 'Bearer ' + base64
	return 'Bearer '+token
}

// http拦截：是在axios请求发出之前给每一个接口携带token去后端校验身份
instance.interceptors.request.use(
	config =>{
		let token = localStorage.getItem('token')
		//console.log(token)
		if(token){
			//console.log(token);
			config.headers.Authorization = baseFun()
		}
		//console.log(config);
		return config
	},
	err =>{
		return Promise.reject(err)
	}
)

//  http拦截：是在axios请求发出之后
instance.interceptors.response.use(
	response =>{
		return response
	},
	error =>{
		if(error.response){
			//console.log(error)
			let ERRS =  error.response.status
			console.log(ERRS)
			//let MSG =  error.response.data.msg.msg
			let MSG =  '还未登录，请先登录'
			console.log(MSG)
			let errdata = ERRS == 401 ? MSG : '服务器发生错误'
			console.log(errdata)
			switch (ERRS){
				case 401:
					//window.location.href = '/login'
				// 没有访问权限，token过期，没有携带token请求，token错误
				// ElMessageBox.alert(errdata, '提示',{
				// 	confirmButtonText: '好的',
				// 	type:"error"
				// })
				// .then(res=>{
				// 	console.log(res);
				// 	// 跳转到登录界面
				// 	window.location.href = '/login'
				// })
				// .catch(err=>{
				// 	console.log(err);
				// 	// 跳转到登录界面
				// 	//window.location.href = '/login'
				// })
				break;
			}
		}
		console.log(error.response)
		return Promise.reject(error.response)//返回接口的错误信息
		//console.log(error.response)
	}
)

export default instance
